import { AmericanFlagIcon, TurkishFlagIcon } from "@Components/Base/Icons";
import { SvgIconProps } from "@mui/material";
import { CustomTypeOptions } from "i18next";
import { Keys } from "../../@types/i18next";
import { JSX } from "react";

export const Languages: {
  label: NestedKeyOf<Keys>;
  value: keyof CustomTypeOptions["resources"];
  icon: (props: SvgIconProps) => JSX.Element;
}[] = [
  {
    label: "LANGUAGES.TURKISH",
    value: "tr",
    icon: TurkishFlagIcon,
  },
  {
    label: "LANGUAGES.ENGLISH",
    value: "en",
    icon: AmericanFlagIcon,
  },
];

export const DEFAULT_LANGUAGE = Languages[0];
